import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME } from './constants';

class UzaverkaNdProvider extends BaseApi {
	async provestUzaverku(uzaverkaSkladu: any) {
		return this.post(`/${DMS_MODULE}/${API_NAME}`, uzaverkaSkladu);
	}
}
export const apiProvider = new UzaverkaNdProvider(DMS_MODULE, API_NAME);
